import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params,Router } from '@angular/router';
import { GlobalService } from 'src/app/services/shared/global.service';
import { CountryService } from 'src/app/services/countries/country.service';

@Component({
  selector: 'app-edit-country',
  templateUrl: './edit-country.component.html',
  styleUrls: ['./edit-country.component.css']
})
export class EditCountryComponent implements OnInit{
   form!: FormGroup;
    public errorMessage: string | null = null;
    isProcessing: boolean = false;
    submitted: boolean = false;
    public Id: string | null = null;
    public countryData:any;

    constructor(
      private countryService:CountryService,
      private formBuilder: FormBuilder,
      private router: Router,
      private globalService: GlobalService,
      private activatedRoute: ActivatedRoute,
    ){
      this.form = this.formBuilder.group({
        country_name: ['', Validators.required],
      });
    }

  ngOnInit(): void {
    this.activatedRoute.paramMap.subscribe((param: Params)=>{
      this.Id = param['get']('id')
    })

    if(this.Id){
      this.fetchCountryData(this.Id);
    }else{
      //Navigate back to users list with error
      this.globalService.setGlobalErrorMessage("Unable to select country for editing!");
      this.router.navigate(['settings/countries']);
    }
  }

   /**
   * Get country data
   * @param Id
   */
   fetchCountryData(Id: string): void {
    this.countryService.edit(Id)
    .subscribe({
      next: (response) => {
        if (response && Object.keys(response).length === 0) {
          this.errorMessage="Oops! A problem was encountered while processing your request. Please refresh the page and try again!";
        }else{
          this.countryData = response;
          if(this.countryData.status==='no_data' || this.countryData.status.length===0){
            this.errorMessage=this.countryData.message;
          }
        }
      },
      error: (error) => {
        this.errorMessage=error;
      }
    });
  }

  handleSubmit():void{
    this.submitted=true;
    this.isProcessing = true;

    if (this.form.valid) {
      const formData = {
        ...this.form.value,
      };

      this.countryService.update(formData,this.Id).subscribe(response => {
        if(response.status==='success'){

          this.submitted=false;
          this.isProcessing = false;
          this.globalService.setGlobalSuccessMessage(response.message);

          // Redirect back to the list
          this.router.navigate(['settings/countries']);
        }else if(response.status==='error'){
          this.submitted=false;
          this.isProcessing = false;
          this.globalService.setGlobalErrorMessage(response.message);
        }else{
          this.submitted=false;
          this.isProcessing = false;
          this.errorMessage="Oops! A problem was encountered while processing your request. Please try again or consult your system administrator.";
        }
      },
      error => {
        this.isProcessing = false;
        this.errorMessage=error;
      });
    }else{
      this.isProcessing = false;
    }
  }
}
